(() => {
  'use strict';
  const motionOff = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const tabs = (root) => {
    root.querySelectorAll('[data-bv-tabs]').forEach(group => {
      if (group.dataset.bvReady === 'true') return;
      const buttons = [...group.querySelectorAll('[data-bv-tab]')];
      const panels = [...group.querySelectorAll('[data-bv-panel]')];
      if (!buttons.length || !panels.length) return;
      const activate = (index, focus) => {
        buttons.forEach((button, i) => {
          const active = i === index;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel, i) => {
          panel.classList.toggle('is-active', i === index);
          panel.setAttribute('aria-hidden', String(i !== index));
        });
        if (focus) buttons[index].focus();
      };
      buttons.forEach((button,i) => {
        button.addEventListener('click', () => activate(i, false));
        button.addEventListener('keydown', e => {
          let next = i;
          if (e.key === 'ArrowRight') next = (i + 1) % buttons.length;
          else if (e.key === 'ArrowLeft') next = (i + buttons.length - 1) % buttons.length;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = buttons.length - 1;
          else return;
          e.preventDefault();
          activate(next,true);
        });
      });
      group.dataset.bvReady = 'true';
      activate(0,false);
    });
  };
  let revealObserver;
  const reveals = root => {
    if (motionOff || !('IntersectionObserver' in window)) { root.querySelectorAll('[data-bv-reveal]').forEach(el => el.classList.add('is-visible')); return; }
    if (!revealObserver) revealObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, {threshold: .08, rootMargin:'0px 0px -20px 0px'});
    root.querySelectorAll('[data-bv-reveal]').forEach(el => {
      if (!el.dataset.bvObserved) {
        el.dataset.bvObserved='true';
        revealObserver.observe(el);
      }
    });
  };
  const initialize = root => {
    tabs(root);
    reveals(root);
  };
  let ticking = false;
  const updateMotion = () => {
    ticking=false;
    const progress=document.querySelector('[data-bv-story-progress]');
    const allSections=[...document.querySelectorAll('[data-bv-story]')];
    if (progress && allSections.length) {
      const start=allSections[0].getBoundingClientRect().top+window.scrollY;
      const end=allSections[allSections.length-1].getBoundingClientRect().bottom+window.scrollY-window.innerHeight;
      const value=end>start?Math.max(0,Math.min(1,(window.scrollY-start)/(end-start))):0;
      progress.style.transform='scaleX('+value.toFixed(3)+')';
    }
    if(motionOff)return;
    document.querySelectorAll('[data-bv-parallax]').forEach(el=>{
      const rect=el.parentElement.getBoundingClientRect();
      if(rect.bottom<0||rect.top>window.innerHeight)return;
      const center=(rect.top+rect.height/2-window.innerHeight/2)/window.innerHeight;
      const shift=Math.max(-40,Math.min(40,-center*42));
      el.style.setProperty('--bv-parallax-y',shift.toFixed(1)+'px');
    });
  };
  const onScroll = () => {
    if (!ticking) {ticking=true;window.requestAnimationFrame(updateMotion);}
  };
  const onReady = () => {
    document.documentElement.classList.add('bv-story-js');
    initialize(document);
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll,{passive:true});
    document.addEventListener('shopify:section:load', e => {initialize(e.target);onScroll();});
    onScroll();
  };
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',onReady,{once:true});
  else onReady();
})();